export default __webpack_public_path__ + "static/WorkSans-Medium-b0ad3154b9ac55c9572994f3261cf47d.woff2";